/**
 * Created by portiz on 8/15/2018.
 */
import React from 'react';
import {Card, CardBody, Col, Button, Form, FormGroup, Label, CardHeader, Row, Container} from 'reactstrap';
import {Spring} from 'react-spring'
import {TimingAnimation, Easing} from 'react-spring/dist/addons'

/** Multiple Language imports **/
import {withLocalize} from "react-localize-redux";
import {renderToStaticMarkup} from 'react-dom/server'; // Fix by the author. Do not remove even if it's not resolved
import {Translate} from "react-localize-redux";
import global from "../translations/global.json"
/** End of Multiple Language imports **/

import LanguageManager from '../custom-classes/language-manager';
import NavbarMobile from './navbar/navbar-mobile';
import FormGroupNewPassword from './forms/form-group-new-password';
import FormGroupName from './forms/form-group-name';
import ModalGeneric from './modals/modal-generic';
import SelectorSex from './selectors/selector-sex';
import DatePicker from './date-picker/date-picker';
import moment from 'moment';
import ApiCalls from '../custom-classes/api-calls';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import SelectorStudent from './selectors/selector-student';
import ModalUserPlan from './modals/modal-user-plans';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faPlusCircle} from '@fortawesome/free-solid-svg-icons';

/**
 * The form to register new users
 */
class ProfileUpdate extends React.Component {

    constructor(props) { // start with a constructor if we want to do modifications on events
        super(props); // Super is required.

        // Declare the properties and set the value according to what we are going to manage in the the page
        this.state = {
            profileId: null,
            firstName: '',
            lastName: '',
            password: '',
            passwordRetype: '',
            username: '',
            dob: null,
            sex: '',
            validPassword: false,
            usernameAvailable: true,
            validUsername: false,
            validFirstName: true,
            validLastName: true,
            propsModal: null,
            showErrorModal: false,
            createdAt: moment(),
            calendarFocused: false,
            proceedUpdateInformation: false,
            proceedUpdatePassword: false
        };

        // To support language library add the following lines
        this.props.initialize({
            languages: [
                {name: "English", code: "en"},
                {name: "Español", code: "es"}
            ],
            options: {renderToStaticMarkup, defaultLanguage: LanguageManager.getLanguage("en")}
        });
        this.props.addTranslation(global);

        this.setUpdateInformationButtonState = this.setUpdateInformationButtonState.bind(this);
        this.setSubmitPasswordButtonState = this.setSubmitPasswordButtonState.bind(this);
        this.toggleAlertModal = this.toggleAlertModal.bind(this);
        this.updateStudentInformation = this.updateStudentInformation.bind(this);
        this.updatePassword = this.updatePassword.bind(this);
    }

    /**
     * Renders the generic modal
     * @returns {XML}
     */
    renderGenericModal() {
        return (
            <ModalGeneric data={this.state.propsModal} updateParent={this.toggleAlertModal}/>
        );
    }

    /**
     * Toggles alert modal (alert from registration)
     */
    toggleAlertModal() {
        this.setState({showErrorModal: false});
    }

    /**
     * Updates the profile password
     */
    updatePassword() {
        // Updates the student information
        let apiCall = ApiCalls.updateProfilePassword(this.state.password, this.state.passwordRetype, this.state.profileId.value);

        apiCall.then((returned)=> {
            let propsModal = {
                bodyText: returned.Messages[0],
                visible: true
            };
            this.setState({propsModal: propsModal, showErrorModal: true, loading: false});
        });
    }

    /**
     * Updates the user information
     */
    updateStudentInformation() {
        // Updates the student information
        let apiCall = ApiCalls.updateProfileInformation(this.state.firstName, this.state.lastName, this.state.sex,
            this.state.dob, this.state.profileId.value);

        apiCall.then((returned)=> {
            let propsModal = {
                bodyText: returned.Messages[0],
                visible: true
            };
            this.setState({propsModal: propsModal, showErrorModal: true, loading: false});
        });
    }

    /**
     * Sets the submit password button state
     */
    setSubmitPasswordButtonState() {
        this.setState({
            proceedUpdatePassword: (
                this.state.validPassword && this.state.profileId !== null
            )
        });
    }

    /**
     * Sets if submit button is ready or not
     */
    setUpdateInformationButtonState() {

        this.setState({
            proceedUpdateInformation: (
                this.state.firstName.length > 0 &&
                this.state.lastName.length > 0 &&
                this.state.validFirstName &&
                this.state.validLastName &&
                this.state.profileId !== null
            )
        });

    }

    /**
     * Sets the student ID and calls the user information
     * @param field
     */
    saveStudentIdState = (field) => (newValue)=> {
        this.setState({profileId: newValue}, ()=> {
            let apiCall = ApiCalls.getProfileInformation(newValue.value);
            apiCall.then((returned)=> {
                console.log(returned.ProfilesAccountModel.UserFullNameModel);
                if (returned.TransactionValid) {
                    this.setState(
                        {
                            firstName: returned.ProfilesAccountModel.UserFullNameModel.GivenName,
                            lastName: returned.ProfilesAccountModel.UserFullNameModel.Surname,
                            dob: (returned.ProfilesAccountModel.UserDobModel !== null
                                ? returned.ProfilesAccountModel.UserDobModel.Dob : null),
                            sex: (returned.ProfilesAccountModel.UserGenderModel !== null
                                ? returned.ProfilesAccountModel.UserGenderModel.Gender : null)

                        }, ()=> {
                            this.setUpdateInformationButtonState();
                        }
                    );
                }
            });
        })
    };

    /**
     * Save the password state and verifies if the next button is ready
     * @param field
     */
    savePassword = (field) => (newValue) => {
        this.setState({
            'password': newValue.password, 'passwordRetype': newValue.passwordRetype,
            'validPassword': newValue.validPassword
        }, () => {
            this.setSubmitPasswordButtonState();
        });
    };

    /**
     * Save the name details and verifies if the next button is ready
     * @param field
     */
    saveName = (field) => (newValue) => {
        this.setState({
            'firstName': newValue.firstName, 'lastName': newValue.lastName,
            'validFirstName': newValue.validFirstName, 'validLastName': newValue.validLastName
        }, () => {
            this.setUpdateInformationButtonState();
        });
    };

    /**
     * Saves the sex
     * @param field
     */
    saveSex = (field) => (newValue) => {
        this.setState({'sex': newValue}, ()=> {
            this.setUpdateInformationButtonState();
        });
    };

    /**
     * Saves the DOB                        */
    saveDob = (field) => (newValue)=> {
        this.setState({'dob': newValue.date}, ()=> {
            this.setUpdateInformationButtonState();
        });
    };

    /**
     * Renders the first part of the form
     * @returns {XML}
     */
    renderForm() {
        return (
            <div>
                <Container>
                    <Row>
                        <Col sm={{size: 12, offset: 0}} md={{size: 12}} lg={{size: 12}}>
                            <Card className="card-white">
                                <CardHeader className="card-cyan">
                                    <h4 className="white-text">
                                        <Translate id="profile-update.edit-profile-select-student"
                                                   options={{renderInnerHtml: false}}/>
                                    </h4>
                                </CardHeader>
                                <CardBody>
                                    <SelectorStudent data={this.state} updateParent={this.saveStudentIdState()}/>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>

                <Container>
                    <Row>
                        <Col sm={{size: 12, offset: 0}} md={{size: 6}} lg={{size: 6}}>
                            <Card className="card-white">
                                <CardHeader className="card-cyan">
                                    <h4 className="white-text">
                                        <Translate id="profile-update.edit-profile" options={{renderInnerHtml: false}}/>
                                    </h4>
                                    <small>
                                        <Translate id="profile-update.edit-profile-subtitle"
                                                   options={{renderInnerHtml: true}}/>
                                    </small>
                                </CardHeader>
                                <CardBody>
                                    <Form>
                                        <FormGroupName data={this.state} updateParent={this.saveName()}/>
                                        <FormGroup row>
                                            <Col sm={{size: 10, offset: 1}}>
                                                <Label for="sex">
                                                    <Translate id="profile-register.sex"/>
                                                </Label>
                                                <SelectorSex value={this.state.sex} data={this.state}
                                                             updateParent={this.saveSex()}/>
                                            </Col>
                                        </FormGroup>

                                        <FormGroup row>
                                            <Col sm={{size: 10, offset: 1}}>
                                                <Label for="dob">
                                                    <Translate id="profile-register.dob"/>
                                                </Label>
                                                <DatePicker data={this.state} updateParent={this.saveDob()}/>
                                            </Col>
                                        </FormGroup>
                                        <FormGroup row>
                                            <Col sm={{size: 10, offset: 1}}>
                                                <Button color="success" block
                                                        disabled={!this.state.proceedUpdateInformation}
                                                        onClick={this.updateStudentInformation}>
                                                    <Translate id="profile-update.update-information"
                                                               options={{renderInnerHtml: false}}/>
                                                </Button>
                                            </Col>
                                        </FormGroup>
                                    </Form>
                                </CardBody>
                            </Card>
                        </Col>

                        <Col sm={{size: 12, offset: 0}} md={{size: 6}} lg={{size: 6}}>
                            <Container>
                                <Row>

                                    <Card className="card-white">
                                        <CardHeader className="card-cyan">
                                            <h4 className="white-text">
                                                <Translate id="profile-update.reset-profile-password"
                                                           options={{renderInnerHtml: false}}/>
                                            </h4>
                                            <small>
                                                <Translate id="profile-update.reset-profile-password-subtitle"
                                                           options={{renderInnerHtml: true}}/>
                                            </small>
                                        </CardHeader>
                                        <CardBody>
                                            <Form>
                                                <FormGroupNewPassword data={this.state}
                                                                      updateParent={this.savePassword()}/>
                                                <Button color="success" block
                                                        disabled={!this.state.proceedUpdatePassword}
                                                        onClick={this.updatePassword}>
                                                    <Translate id="profile-update.save-password"
                                                               options={{renderInnerHtml: false}}/>
                                                </Button>
                                            </Form>
                                        </CardBody>
                                    </Card>
                                </Row>
                            </Container>
                        </Col>
                    </Row>
                </Container>
            </div>
        )
    };

    /**
     * Renders the main form element
     * @returns {XML}
     */
    render() {
        return (

            <Spring from={{opacity: 0}} to={{opacity: 1}} impl={TimingAnimation}
                    config={{duration: 450, easing: Easing.linear}}>
                {
                    styles => <div>
                        <NavbarMobile/>
                        {this.renderForm()}
                        {this.state.showErrorModal ? this.renderGenericModal() : null}
                    </div>
                }
            </Spring>
        )
    }
}

export default withLocalize(ProfileUpdate);


// WEBPACK FOOTER //
// ./src/components/profile-update.js